var map = {
	"./locale-provider/ar_EG.tsx": 991,
	"./locale-provider/bg_BG.tsx": 995,
	"./locale-provider/ca_ES.tsx": 999,
	"./locale-provider/cs_CZ.tsx": 1003,
	"./locale-provider/de_DE.tsx": 1007,
	"./locale-provider/el_GR.tsx": 1011,
	"./locale-provider/en_GB.tsx": 1015,
	"./locale-provider/en_US.tsx": 1019,
	"./locale-provider/es_ES.tsx": 1020,
	"./locale-provider/et_EE.tsx": 1024,
	"./locale-provider/fa_IR.tsx": 1028,
	"./locale-provider/fi_FI.tsx": 1032,
	"./locale-provider/fr_BE.tsx": 1036,
	"./locale-provider/fr_FR.tsx": 1040,
	"./locale-provider/is_IS.tsx": 1044,
	"./locale-provider/it_IT.tsx": 1048,
	"./locale-provider/ja_JP.tsx": 1052,
	"./locale-provider/ko_KR.tsx": 1056,
	"./locale-provider/ku_IQ.tsx": 1060,
	"./locale-provider/nb_NO.tsx": 1064,
	"./locale-provider/nl_BE.tsx": 1068,
	"./locale-provider/nl_NL.tsx": 1072,
	"./locale-provider/pl_PL.tsx": 1076,
	"./locale-provider/pt_BR.tsx": 1080,
	"./locale-provider/pt_PT.tsx": 1084,
	"./locale-provider/ru_RU.tsx": 1088,
	"./locale-provider/sk_SK.tsx": 1092,
	"./locale-provider/sr_RS.tsx": 1096,
	"./locale-provider/sv_SE.tsx": 1100,
	"./locale-provider/th_TH.tsx": 1104,
	"./locale-provider/tr_TR.tsx": 1108,
	"./locale-provider/uk_UA.tsx": 1110,
	"./locale-provider/vi_VN.tsx": 1114,
	"./locale-provider/zh_CN.tsx": 1118,
	"./locale-provider/zh_TW.tsx": 1121
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 990
// module chunks = 0